import { db, FirebaseTimestamp, functions } from "../../firebase"
import { push } from 'connected-react-router'
import { deleteProductAction, fetchProductsAction } from './actions'

const productsRef = db.collection('products')
const usersRef = db.collection('users')

export const deleteProduct = (id) => {
    return async (dispatch, getState) => {
        productsRef.doc(id).delete()
            .then(() => {
                const prevProducts = getState().products.list;
                const nextProducts = prevProducts.filter(product => product.id !== id)
                dispatch(deleteProductAction(nextProducts))
            })
    }
}

export const fetchProducts = (brand, category) => {
    return async (dispatch) => {
        let query = productsRef.orderBy('updated_at','desc')
        query = brand ? query.where("brand", "==", brand) : query
        query = category ? query.where("category", "==", category) : query
        query.get()
             .then(snapshots => {
                const productList = []
                snapshots.forEach(snapshot => {
                    const product = snapshot.data()
                    productList.push(product)
                })
                dispatch(fetchProductsAction(productList))
            })
    }
}

export const orderProduct = (productListInCart, amount, user, shippingFee) => {
    return async (dispatch, getState) => {
        const uid = getState().users.uid
        const customerId = getState().users.customer_id
        const paymentMethodId = getState().users.payment_method_id
        const userRef = usersRef.doc(uid)
        const timestamp = FirebaseTimestamp.now()

        let products = [],
            soldOutProducts = [];

        const batch = db.batch()

        // カート内の商品ごとの処理
        for (const product of productListInCart) {
            // カート内商品の情報を取
            const productSnapshot = await productsRef.doc(product.productId).get()
            const purchasingProduct = productSnapshot.data()
            const variationSnapshot = await productsRef.doc(product.productId)
                                                        　.collection('variations')
                                                        　.doc(product.variationId)
                                                        　.get()
            purchasingProduct.variation = variationSnapshot.data()

            // カート内商品の在庫数をへらす（注文数の方が多い場合は在庫切れリストへ）
            if (purchasingProduct.variation.quantity < product.quantity ) {
                soldOutProducts.push(purchasingProduct.name + " " + purchasingProduct.variation.variationName)
            } else {
                purchasingProduct.variation.quantity -= product.quantity
            }

            // 注文内容情報に商品を追加
            products.push(
                {
                    id: product.productId,
                    brand: product.brand,
                    name: product.name,
                    images: product.images,
                    price: product.price,
                    discount: product.discount,
                    quantity: product.quantity,
                    variationName: product.variationName
                }
            )

            // 在庫数を減らす処理
            batch.update (
                productsRef.doc(product.productId)
                        　　.collection('variations')
                        　　.doc(product.variationId),
                { quantity: purchasingProduct.variation.quantity }
            )

            // カート内を空にする処理 
            batch.delete (
                userRef.collection('cart')
                    　　.doc(product.cartId)
            )
        }

        // 在庫エラー処理
        if (soldOutProducts.length > 0) {
            const errorMessage = (soldOutProducts.length > 1) ?
                                 soldOutProducts.join('と') : 
                                 soldOutProducts[0];
            alert('大変申し訳ございません' + errorMessage + 'が在庫切れとなりました。注文処理を中断します。')
            return false;
        }

        // 決済処理
        const paymentIntent = await createPaymentIntent(amount, customerId, paymentMethodId)

        if (paymentIntent.error) {
            alert('決済処理に失敗しました。注文処理を中断します。')
            return false;
        } else {
            batch.commit()
                .then( () => {
                    // Firestoreを更新
                    const orderRef = userRef.collection('orders').doc()
                    const orderData = {
                        amount,
                        shipping_fee: shippingFee,
                        created_at: timestamp,
                        id: orderRef.id,
                        status: '発送待ち',
                        products: products,
                        user: {
                            id:uid,
                            firstname: user.firstname,
                            lastname: user.lastname,
                            postalCode: user.postalCode,
                            prefecture: user.prefecture,
                            city: user.city,
                            street: user.street,
                        },
                        updated_at: timestamp
                    }
                    orderRef.set(orderData)
                    const mailData = {
                        to: 'Jeff.S.63mSwHfl@gmail.com',
                        subject: '【Weth-Store】注文が完了しました',
                        text: `
ご注文ありがとうございます。
ご注文に関する情報は下記の通りです。
お届け先住所：〒${user.postalCode} ${user.prefecture}${user.city}${user.street}
お届け先氏名：${user.lastname} ${user.firstname}
合計金額：${amount}
`
                    }
                    const sendMail = functions.httpsCallable('sendMail')
                    sendMail(mailData)
                    dispatch(push('/order/complete'))

                }).catch( (e) => {
                    console.error(e)
                    alert('注文処理に失敗しました。通信環境をご確認のうえ、もう一度お試しください。')
                    return false;
                })
        }

    }
}

export const saveProduct = (id, images, name, description, brand, category, price, discount, variations, metaTitle, metaDescription, metaKeywords, isDraft, isTrash) => {
    return async (dispatch) => {

        // 画像 Validation
        if (!images || images.length === 0) {
            alert('画像が設定されていません')
            return false
        }
        
        if (name === '' || description === '' || brand === '' || price === '' || discount === '' ) {
            alert('必須項目が未入力です')
            return false
        }
        if (isNaN(price)) {
            alert('価格に数値以外が入力されています。半角数字で100~100,000(円)の数値を入力してください。')
            return false
        }
        if (price < 100 || price > 100000 ) {
            alert('価格が適正ではありません。半角数字で100円~100,000(円)の数値を入力してください。')
            return false
        }
        if (isNaN(discount)) {
            alert('価割引率に数値以外が入力されています。半角数字で0~100(%)の数値を入力してください。')
            return false
        }
        if (discount < 0 || discount > 100 ) {
            alert('割引率が適正ではありません。半角数字で0~100(%)の数値を入力してください。')
            return false
        }

        const timestamp = FirebaseTimestamp.now()
        const data = {
            images, name, description, brand, category,
            price: parseInt(price, 10),
            discount: parseInt(discount, 10),
            metaTitle, metaDescription, metaKeywords,
            isDraft, isTrash,
            updated_at: timestamp
        }

        if (id === '') {
            const ref = productsRef.doc()
            id = ref.id
            data.id = id
            data.created_at = timestamp
        }

        const variationsRef = productsRef.doc(id).collection('variations')
    
        // バリエーション毎のデータセット
        const variationsData = []
        for (const [key, section] of variations.entries()) {
        // variations.forEach((section, key) => {

            // Validation
            if (section.quantity === '') {
                alert(`バリエーション${key+1}の在庫数が入力されていません`)
                return false
            }
            if (isNaN(section.quantity)) {
                alert(`バリエーション${key+1}の在庫数に数値以外が入力されています。半角数字で0~1000(個)の数値を入力してください。`)
                return false
            }
            if (section.quantity < 0 || section.quantity > 100 ) {
                alert(`バリエーション${key+1}の在庫数が適正ではありません。半角数字で0~1000(個)の数値を入力してください。`)
                return false
            }
            if (variations.length > 1) {
                if (section.variationName === '') {
                    alert(`バリエーション${key+1}のバリエーション名が入力されていません`)
                    return false
                }
            }

            variationsData[key] = {
                order: key+1,
                variationName: section.variationName, 
                quantity: section.quantity,
                updated_at: timestamp
            }
            if (!section.id) {
                const newSectionId = variationsRef.doc().id
                variationsData[key].id = newSectionId
                variationsData[key].created_at = timestamp
            } else {
                variationsData[key].id = section.id
            }
            
        }

        return productsRef.doc(id).set(data, {merge: true})
            .then(() => {
                // variationsの内容を保存
                variations.forEach((x,key)=>{
                    variationsRef.doc(variationsData[key].id)
                                 .set(variationsData[key], {merge: true})
                })
                dispatch(push('/admin/product')) 
            }).catch( error => {
                throw new Error(error)
            })
    }
}


// 決済処理

// API
const headers = new Headers();
headers.set('Content-type', 'application/json');
const BASE_URL = 'https://weth-store.web.app';

export const createPaymentIntent = async (amount, customerId, paymentMethodId) => {
    const response = await fetch(BASE_URL + '/v1/paymentIntent', {
        method: 'POST',
        headers,
        body: JSON.stringify({
            amount,
            customerId,
            paymentMethodId,
        })
    })

    const paymentIntentResponse = await response.json()
    return JSON.parse(paymentIntentResponse.body)
}